"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlansCatalog = exports.AlternateProductCodes = exports.StorageProductCodes = exports.AvailableAddOns = exports.AvailableProductUpgrades = exports.TrialNotAvailableProductUpgrades = exports.PlanKeyToProductCode = exports.ProductCodeToPlanKey = exports.ProductCodes = void 0;
const common_1 = require("./common");
exports.ProductCodes = {
    STANDARD: 'SFSTD001',
    STANDARD0GB: 'SFSTD002',
    ADVANCED: 'SFADV001',
    ADVANCED0GB: 'SFADV002',
    PREMIUM: 'SFPREM001',
    INDUSTRY_ADVANTAGE: 'SFIA001',
    RS_INDUSTRY_ADVANTAGE: 'RSIA001',
    VDR: 'SFVDR001',
    STORAGEPACK500GB: 'SF500GB',
    RSADVANCEDKBA: 'RSADVKBA001',
    ESIGADDON: 'RSADDON001',
    PODIOPLUS: 'PPLUS001',
    PODIOPREMIUM: 'PPREM001',
    PREMIUMSUPPORT: 'SUPPORTPREM',
    STORAGEPACK3TB: 'SF3TB',
    CONNECTORS0GB: 'SFCONNECT002',
};
exports.ProductCodeToPlanKey = new Map([
    [exports.ProductCodes.STANDARD, common_1.PlanName.STANDARD],
    [exports.ProductCodes.ADVANCED, common_1.PlanName.ADVANCED],
    [exports.ProductCodes.PREMIUM, common_1.PlanName.PREMIUM],
    [exports.ProductCodes.INDUSTRY_ADVANTAGE, common_1.PlanName.INDUSTRY_ADVANTAGE],
    [exports.ProductCodes.VDR, common_1.PlanName.VDR],
]);
exports.PlanKeyToProductCode = new Map([
    ['ShareFile Standard', exports.ProductCodes.STANDARD],
    ['ShareFile Standard 0GB', exports.ProductCodes.STANDARD0GB],
    ['ShareFile Advanced', exports.ProductCodes.ADVANCED],
    ['ShareFile Advanced 0GB', exports.ProductCodes.ADVANCED0GB],
    ['ShareFile Premium', exports.ProductCodes.PREMIUM],
    ['ShareFile Industry Advantage', exports.ProductCodes.INDUSTRY_ADVANTAGE],
    ['ShareFile VDR', exports.ProductCodes.VDR],
    ['ShareFile Connectors 0GB', exports.ProductCodes.CONNECTORS0GB],
]);
exports.TrialNotAvailableProductUpgrades = [
    exports.ProductCodes.STANDARD0GB,
    exports.ProductCodes.ADVANCED0GB,
    exports.ProductCodes.CONNECTORS0GB,
    exports.ProductCodes.STANDARD,
];
exports.AvailableProductUpgrades = {
    [exports.ProductCodes.STANDARD]: [
        exports.ProductCodes.ADVANCED,
        exports.ProductCodes.PREMIUM,
        exports.ProductCodes.INDUSTRY_ADVANTAGE,
    ],
    [exports.ProductCodes.STANDARD0GB]: [
        exports.ProductCodes.STANDARD,
        exports.ProductCodes.ADVANCED,
        exports.ProductCodes.ADVANCED0GB,
        exports.ProductCodes.PREMIUM,
        exports.ProductCodes.INDUSTRY_ADVANTAGE,
    ],
    [exports.ProductCodes.ADVANCED]: [exports.ProductCodes.PREMIUM, exports.ProductCodes.INDUSTRY_ADVANTAGE],
    [exports.ProductCodes.ADVANCED0GB]: [
        exports.ProductCodes.ADVANCED,
        exports.ProductCodes.PREMIUM,
        exports.ProductCodes.INDUSTRY_ADVANTAGE,
    ],
    [exports.ProductCodes.PREMIUM]: [exports.ProductCodes.INDUSTRY_ADVANTAGE],
    [exports.ProductCodes.RSADVANCEDKBA]: [exports.ProductCodes.PREMIUM, exports.ProductCodes.INDUSTRY_ADVANTAGE],
    [exports.ProductCodes.PODIOPLUS]: [exports.ProductCodes.PODIOPREMIUM],
    [exports.ProductCodes.CONNECTORS0GB]: [
        exports.ProductCodes.STANDARD0GB,
        exports.ProductCodes.STANDARD,
        exports.ProductCodes.ADVANCED,
        exports.ProductCodes.ADVANCED0GB,
        exports.ProductCodes.PREMIUM,
        exports.ProductCodes.INDUSTRY_ADVANTAGE,
    ],
};
exports.AvailableAddOns = [
    exports.ProductCodes.STORAGEPACK3TB,
    exports.ProductCodes.STORAGEPACK500GB,
];
exports.StorageProductCodes = [
    exports.ProductCodes.STORAGEPACK3TB,
    exports.ProductCodes.STORAGEPACK500GB,
];
exports.AlternateProductCodes = new Map([
    [exports.ProductCodes.STANDARD, ['SFSTD001-NFR-Workspace']],
    [exports.ProductCodes.ADVANCED0GB, ['SFADV002-NFR-Workspace']],
    [exports.ProductCodes.PREMIUM, ['SFPREM001-NFR-Workspace']],
]);
// dbryan/jmstines: Hardcoded values for now until we pull from hybris. 7-12-2023 / 8-10-23
exports.PlansCatalog = [
    {
        productCode: exports.ProductCodes.STANDARD,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Standard',
        minQty: 3,
        monthly: {
            pricePerUser: 11.0,
            perUserPerMonthPrice: 11.0,
            perUserPerYearPrice: 132.0,
        },
        annually: {
            pricePerUser: 10.0,
            perUserPerMonthPrice: 10.0,
            perUserPerYearPrice: 120.0,
        },
    },
    {
        productCode: exports.ProductCodes.ADVANCED,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Advanced',
        minQty: 3,
        monthly: {
            pricePerUser: 17.6,
            perUserPerMonthPrice: 17.6,
            perUserPerYearPrice: 211.2,
        },
        annually: {
            pricePerUser: 16.0,
            perUserPerMonthPrice: 16.0,
            perUserPerYearPrice: 192.0,
        },
    },
    {
        productCode: exports.ProductCodes.PREMIUM,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Premium',
        minQty: 3,
        monthly: {
            pricePerUser: 27.5,
            perUserPerMonthPrice: 27.5,
            perUserPerYearPrice: 330.0,
        },
        annually: {
            pricePerUser: 25.0,
            perUserPerMonthPrice: 25.0,
            perUserPerYearPrice: 300.0,
        },
    },
    {
        productCode: exports.ProductCodes.STANDARD0GB,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Standard 0GB',
        minQty: 3,
        monthly: {
            pricePerUser: 5.5,
            perUserPerMonthPrice: 5.5,
            perUserPerYearPrice: 66.0,
        },
        annually: {
            pricePerUser: 5.0,
            perUserPerMonthPrice: 5.0,
            perUserPerYearPrice: 60.0,
        },
    },
    {
        productCode: exports.ProductCodes.ADVANCED0GB,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Advanced 0GB',
        minQty: 3,
        monthly: {
            pricePerUser: 11.0,
            perUserPerMonthPrice: 11.0,
            perUserPerYearPrice: 132.0,
        },
        annually: {
            pricePerUser: 10.0,
            perUserPerMonthPrice: 10.0,
            perUserPerYearPrice: 120.0,
        },
    },
    {
        productCode: exports.ProductCodes.VDR,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Virtual Data Room',
        minQty: 5,
        monthly: {
            pricePerUser: 75.0,
            perUserPerMonthPrice: 75.0,
            perUserPerYearPrice: 900.0,
        },
        annually: {
            pricePerUser: 67.5,
            perUserPerMonthPrice: 67.5,
            perUserPerYearPrice: 810.0,
        },
    },
    {
        productCode: exports.ProductCodes.STORAGEPACK500GB,
        productFamily: common_1.ProductFamily.AddOn,
        productName: '500 GB Storage Pack',
        minQty: 1,
        monthly: {
            pricePerUser: 36.67,
            perUserPerMonthPrice: 36.67,
            perUserPerYearPrice: 440.0,
        },
        annually: {
            pricePerUser: 33.33,
            perUserPerMonthPrice: 33.33,
            perUserPerYearPrice: 400.0,
        },
    },
    {
        productCode: exports.ProductCodes.RSADVANCEDKBA,
        productFamily: common_1.ProductFamily.RightSignature,
        productName: 'RightSignature Adv KBA',
        minQty: 3,
        monthly: {
            pricePerUser: 22.0,
            perUserPerMonthPrice: 22.0,
            perUserPerYearPrice: 264.0,
        },
        annually: {
            pricePerUser: 20.0,
            perUserPerMonthPrice: 20.0,
            perUserPerYearPrice: 240.0,
        },
    },
    {
        productCode: exports.ProductCodes.ESIGADDON,
        productFamily: common_1.ProductFamily.AddOn,
        productName: 'E-Sign Add-on',
        minQty: 0,
        monthly: {
            pricePerUser: 9.17,
            perUserPerMonthPrice: 9.17,
            perUserPerYearPrice: 110.0,
        },
        annually: {
            pricePerUser: 8.33,
            perUserPerMonthPrice: 8.33,
            perUserPerYearPrice: 100.0,
        },
    },
    {
        productCode: exports.ProductCodes.PODIOPLUS,
        productFamily: common_1.ProductFamily.Podio,
        productName: 'Podio Plus',
        minQty: 3,
        monthly: {
            pricePerUser: 12.32,
            perUserPerMonthPrice: 12.32,
            perUserPerYearPrice: 147.84,
        },
        annually: {
            pricePerUser: 11.2,
            perUserPerMonthPrice: 11.2,
            perUserPerYearPrice: 134.4,
        },
    },
    {
        productCode: exports.ProductCodes.PODIOPREMIUM,
        productFamily: common_1.ProductFamily.Podio,
        productName: 'Podio Premium',
        minQty: 3,
        monthly: {
            pricePerUser: 21.12,
            perUserPerMonthPrice: 21.12,
            perUserPerYearPrice: 253.44,
        },
        annually: {
            pricePerUser: 19.2,
            perUserPerMonthPrice: 19.2,
            perUserPerYearPrice: 230.4,
        },
    },
    {
        productCode: exports.ProductCodes.PREMIUMSUPPORT,
        productFamily: common_1.ProductFamily.Support,
        productName: 'Premium Support',
        minQty: 0,
        monthly: {
            pricePerUser: 0.0,
            perUserPerMonthPrice: 0.0,
            perUserPerYearPrice: 0.0,
        },
        annually: {
            pricePerUser: 0.0,
            perUserPerMonthPrice: 0.0,
            perUserPerYearPrice: 0.0,
        },
    },
    {
        productCode: exports.ProductCodes.STORAGEPACK3TB,
        productFamily: common_1.ProductFamily.AddOn,
        productName: '3TB Pooled Storage Pack',
        minQty: 1,
        monthly: {
            pricePerUser: 66.67,
            perUserPerMonthPrice: 66.67,
            perUserPerYearPrice: 800,
        },
        annually: {
            pricePerUser: 66.67,
            perUserPerMonthPrice: 66.67,
            perUserPerYearPrice: 800,
        },
    },
    {
        productCode: exports.ProductCodes.CONNECTORS0GB,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Connectors 0GB',
        minQty: 3.0,
        monthly: {
            pricePerUser: 33.33,
            perUserPerMonthPrice: 33.33,
            perUserPerYearPrice: 400,
        },
        annually: {
            pricePerUser: 33.33,
            perUserPerMonthPrice: 33.33,
            perUserPerYearPrice: 400,
        },
    },
    {
        productCode: exports.ProductCodes.INDUSTRY_ADVANTAGE,
        productFamily: common_1.ProductFamily.ShareFile,
        productName: 'ShareFile Industry Advantage',
        minQty: 3.0,
        monthly: {
            pricePerUser: 45.83,
            perUserPerMonthPrice: 45.83,
            perUserPerYearPrice: 550,
        },
        annually: {
            pricePerUser: 41.67,
            perUserPerMonthPrice: 41.67,
            perUserPerYearPrice: 500,
        },
    },
];
//# sourceMappingURL=catalog.js.map